import React, {useState, useEffect} from "react";
import Button from 'react-bootstrap/Button';
import ConfirmModal from "../modals/ConfirmModal";
import {QUOTE_DELETE_CONFIRM, QUOTE_DELETE_POPUP_BODY, QUOTE_DELETE_POPUP_HEADER} from "../../constants/constants";

export default function DeleteQuoteButton(props) {

    const [show, setShow] = useState(false);

    useEffect(() => {
        if(props.deleteConfirm) {
            setShow(false);
        }
    }, [props.deleteConfirm])


    const onDeleteHandler = (quoteId) => {
        props.onDeleteHandler(quoteId);
    }

    const onCancelConfirm = () => setShow(false);

    return (
        <>
            <Button type="button" variant="light" size="sm" onClick={() => setShow(true)}>
                {props.btnText}
            </Button>
            <ConfirmModal
                id={props.quoteId}
                onConfirm={() => onDeleteHandler(props.quoteId)}
                onCancelConfirm={onCancelConfirm}
                header={QUOTE_DELETE_POPUP_HEADER}
                body={QUOTE_DELETE_POPUP_BODY}
                confirmTxt={QUOTE_DELETE_CONFIRM}
                show={show}
            />
        </>
    )
}